<form #editForm="ngForm" (ngSubmit)="save(editForm)" class="flex flex-col">
	<div class="flex flex-col w-80 min-w-full">
		<app-input
			label="Description"
			[(ngModel)]="statement.description"
			[required]="true"
			[submitted]="submitted"
			name="description"
		></app-input>
	</div>

	<div class="mt-10">
		<div class="flex flex-col gap-4 mb-5">
			<app-checkbox
				*ngIf="statement.type === StatementOfAccountType.FEE"
				type="clear"
				[(ngModel)]="statement.containsDocumentText"
				name="showText"
				>Add fee statements in document</app-checkbox
			>
			<app-anchor
				type="static"
				*ngIf="viewUrl"
				[url]="viewUrl"
				(onClick)="cancel()"
				>Go to Title insurance</app-anchor
			>
		</div>
		<div *ngIf="statement.containsDocumentText" [@openClose]>
			<app-html-editor
				[document]="statement?.documentHtmlText"
				(onChange)="setDocumentHtmlText($event)"
				[debounceTime]="0"
				minHeight="400px"
				class="mt-5"
			></app-html-editor>
		</div>
	</div>
	<div class="flex items-center justify-between mt-10">
		<app-button (click)="cancel()" btn="tertiary" size="small"
			>Cancel</app-button
		>
		<app-button type="submit" size="small">Save</app-button>
	</div>
</form>
